import $ from 'jquery';

const mainMenu = () => {
	const VIEW_MOBILE_SIZE = 1024;
	const menu = $('.js--main-menu');
	const mainMenuScrolledClassName = 'is--scrolling';
	const mainMenuScrolledBodyClassName = 'is--menu-scrolling';
	const withSubMenu = $('.js--main-menu--with-submenu');
	const activeSubmenuClassName = 'is--opened-submenu';
	const submenuBlock = $('.js--main-menu--submenu');
	const submenuMobileBlock = $('.js--main-menu--submenu-mobile');
	const activeSubmenuMobileClassName = 'is--opened-submenu-mobile';

	const setMobileMenuHeight = () => {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--VIEW-height', `${vh}px`);
	};

	const positionOnScroll = () => {
		const TOP_POSITION = 25;
		const defaultPoint = 0;
		let positionTop;

		if ($(window).scrollTop() > defaultPoint) {
			positionTop = TOP_POSITION - $(window).scrollTop();
		} else {
			positionTop = TOP_POSITION;
		}

		if (positionTop <= 0) {
			positionTop = 0;
		}

		menu.css('top', positionTop + 'px');
	};

	const changeOnScroll = () => {
		if ($(window).scrollTop() > 30) {
			$('body').addClass(mainMenuScrolledBodyClassName);
			menu.addClass(mainMenuScrolledClassName);
		} else {
			$('body').removeClass(mainMenuScrolledBodyClassName);
			menu.removeClass(mainMenuScrolledClassName);
		}
	};

	const subMenuHandle = () => {
		withSubMenu.mouseenter(function () {
			if (window.innerWidth >= VIEW_MOBILE_SIZE) {
				menu.addClass(activeSubmenuClassName);
				setTimeout(function () {
					if (menu.hasClass(activeSubmenuClassName)) {
						submenuBlock.fadeIn(350);
					}
				}, 150);
			}
		}).mouseleave(function () {
			if (window.innerWidth >= VIEW_MOBILE_SIZE) {
				menu.removeClass(activeSubmenuClassName);
				submenuBlock.fadeOut(200);
			}
		});

		withSubMenu.on('click', function (e) {
			if (window.innerWidth < VIEW_MOBILE_SIZE) {
				e.preventDefault();
				menu.toggleClass(activeSubmenuMobileClassName);
				submenuMobileBlock.slideToggle(200);
			}
		});
	};

	subMenuHandle();

	$(window).on('resize', function () {
		setMobileMenuHeight();
	});

	$(window).on('scroll', function () {
		positionOnScroll();
		changeOnScroll();
	});

	$(document).on('ready', function () {
		positionOnScroll();
		changeOnScroll();
		setMobileMenuHeight();
	});
};

const render = () => {
	mainMenu();
};

export default render;
